var Alert                 = require("app/ui/Alert"),
    Checkbox              = require("enyo/Checkbox"),
    ControlGroup          = require("app/ui/ControlGroup"),
    ControlLabel          = require("app/ui/ControlLabel"),
    IconButton            = require("app/ui/IconButton"),
    Input                 = require("app/ui/Input"),
    InputWrapper          = require("app/ui/InputWrapper"),
    PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    PopupLayout           = require("app/AppLayout/PopupLayout"),
    ScrollerPopup         = require("app/ui/ScrollerPopup"),
    SvgIcon               = require("app/ui/SvgIcon"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    closeButtonThemeVars  = require("app/theme/IconButtonVariables--close"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    get                   = require("object-path").get,
    icons                 = require("app/theme/icons"),
    kind                  = require("enyo/kind"),
    logger                = require("enyo/logger"),
    themeVars             = require("app/theme/variables.js");

require("./ChangeIsAdultForm.less");
require("app/ui/ControlGroup.less");
require("app/theme/Alert--success.less");
require("app/theme/Alert--error.less");
require("app/theme/ControlGroup--default.less");
require("app/theme/ControlLabel--default.less");
require("app/theme/Input--default.less");
require("app/theme/IconButton--positive.less");
require("app/theme/IconButton--input-default.less");

module.exports = kind(/** @lends  app.ProfilePage.ChangeIsAdultForm.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.ChangeIsAdultForm",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment:       "fullLayout",
        expand:          false,
        overlapSafeArea: false,

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx()
                + (this.container.get("showCloseButton")
                    ? closeButtonThemeVars.getIconSize() / 2
                    : 0);
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @private
     */
    classes: "app-profile-page-change-is-adult-form",

    /**
     * @public
     */
    theme: "bordered",

    /**
     * @type     {boolean}
     * @default  'false'
     * @readonly
     * @public
     */
    isSubmitting: false,

    /**
     * @private
     */
    components: [{
        classes:    "app-profile-page-change-is-adult-form__form",
        tag:        "form",
        attributes: {
            onsubmit: "return false;"
        },
        components: [{
            name:    "title",
            classes: "app-profile-page-change-is-adult-form__title",
            tag:     "h2"
        }, {
            name:    "body",
            classes: "app-profile-page-change-is-adult-form__body",
            tag:     "p"
        }, {
            name:      "formErrorAlert",
            kind:      Alert,
            classes:   "app-profile-page-change-is-adult-form__form-error-alert",
            theme:     "error",
            showing:   false,
            allowHtml: true
        }, {
            kind:       ControlGroup,
            classes:    "app-profile-page-change-is-adult-form__is-adult",
            components: [{
                name:      "isAdult",
                kind:      ControlLabel,
                tag:       "div",
                classes:   "app-profile-page-change-is-adult-form__is-adult-label",
                groupName: "isAdult"
            }, {
                components: [{
                    name:       "isAdultLabel",
                    tag:        "label",
                    classes:    "app-profile-page-change-is-adult-form__is-adult-label--adult",
                    theme:      "default",
                    components: [{
                        name:       "isAdultRadio",
                        kind:       Checkbox,
                        classes:    "app-profile-page-change-is-adult-form__is-adult-radio--adult",
                        type:       "radio",
                        attributes: {
                            name:  "is_adult",
                            value: 1
                        },
                        groupName: "isAdult"
                    }, {
                        name:    "isAdultIcon",
                        kind:    SvgIcon,
                        classes: "app-profile-page-change-is-adult-form__is-adult-icon--adult"
                    }, {
                        name:    "isAdultCaption",
                        tag:     "span",
                        classes: "app-profile-page-change-is-adult-form__is-adult-caption--adult"
                    }]
                }, {
                    name:       "isKidLabel",
                    tag:        "label",
                    classes:    "app-profile-page-change-is-adult-form__is-adult-label--kid",
                    theme:      "default",
                    components: [{
                        name:       "isKidRadio",
                        kind:       Checkbox,
                        classes:    "app-profile-page-change-is-adult-form__is-adult-radio--kid",
                        type:       "radio",
                        attributes: {
                            name:  "is_adult",
                            value: 0
                        },
                        groupName: "isAdult"
                    }, {
                        name:    "isKidIcon",
                        kind:    SvgIcon,
                        classes: "app-profile-page-change-is-adult-form__is-adult-icon--kid"
                    }, {
                        name:    "isKidCaption",
                        tag:     "span",
                        classes: "app-profile-page-change-is-adult-form__is-adult-caption--kid"
                    }]
                }]
            }]
        }, {
            kind:       ControlGroup,
            classes:    "app-profile-page-change-is-adult-form__password",
            components: [{
                name:  "passwordLabel",
                kind:  ControlLabel,
                theme: "default"
            }, {
                kind:       InputWrapper,
                components: [{
                    name:       "passwordInput",
                    kind:       Input,
                    classes:    "icon-right",
                    type:       "password",
                    attributes: {
                        name:             "password",
                        required:         "required",
                        pattern:          "[\\S]{8,}", // At least 8 characters, no white-space
                        autocomplete:     "current-password",
                        "data-lpignore":  "true",
                        "data-hj-masked": ""
                    },
                    theme:  "default",
                    ontap:  "onFormControlTap",
                    onblur: "onFormControlBlur"
                }, {
                    name:       "passwordVisibility",
                    kind:       IconButton,
                    classes:    "right-of-input app-profile-page-change-is-adult-form__password-visibility-toggle",
                    tag:        "button",
                    attributes: {
                        type: "button"
                    },
                    ondown: "onPasswordVisibilityDown",
                    ontap:  "onPasswordVisibilityTap",
                    theme:  "input-default"
                }]
            }, {
                name:    "passwordInstructions",
                classes: "app-ui-control-instructions"
            }]
        }, {
            kind:       ControlGroup,
            classes:    "app-profile-page-change-is-adult-form__actions",
            components: [{
                name:    "submitButton",
                kind:    IconButton,
                classes: "app-profile-page-change-is-adult-form__submit-button",
                tag:     "button",
                theme:   "positive",
                ontap:   "submit"
            }]
        }]
    }],

    /**
     * @private
     */
    handlers: {
        onActivate: "onActivate"
    },

    /**
     * @private
     */
    observers: {
        update: ["passwordVisible", "isSubmitting"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.authService.user", this.resetForm);
            this.update();
            this.resetForm();
        };
    }),

    /**
     * @method
     * @private
     */
    rendered: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            // Ensure proper label referencing for accessibility
            this.$.isAdultLabel.setAttribute("for", this.$.isAdultRadio.getAttribute("id"));
            this.$.isKidLabel.setAttribute("for", this.$.isKidRadio.getAttribute("id"));
            this.$.passwordLabel.setAttribute("for", this.$.passwordInput.getAttribute("id"));
        };
    }),

    /**
     * @public
     */
    update: function() {
        var authService         = this.app.$.authService,
            i18nService         = this.app.$.i18nService,
            $passwordInput      = this.$.passwordInput,
            $passwordVisibility = this.$.passwordVisibility,
            $submitButton       = this.$.submitButton;

        // Form
        this.$.title.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.title"));
        this.$.body.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.body"));

        // IsAdult
        this.$.isAdult.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.isAdultLabel"));
        this.$.isAdultCaption.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.isAdultCaption"));
        this.$.isKidCaption.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.isKidCaption"));

        if (get(authService, "user.is_adult", null) === true) {
            this.$.isAdultRadio.set("active", true);
        }
        else if (get(authService, "user.is_adult", null) === false) {
            this.$.isKidRadio.set("active", true);
        }
        else {
            this.$.isAdultRadio.set("active", false);
            this.$.isKidRadio.set("active", false);
        }

        // Password
        this.$.passwordLabel.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.Password.label"));
        $passwordInput.set("tooltip", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.Password.instructions"));
        this.$.passwordInstructions.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.Password.instructions"));

        if (this.passwordVisible) {
            $passwordVisibility.set("tooltip", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.HidePassword.tooltip"));
            $passwordVisibility.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.hidePassword"]);
            $passwordInput.setAttribute("type", "text");
        }
        else {
            $passwordVisibility.set("tooltip", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.ShowPassword.tooltip"));
            $passwordVisibility.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.showPassword"]);
            $passwordInput.setAttribute("type", "password");
        }

        // Submit button
        $submitButton.set("caption", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.SubmitButton.caption"));
        $submitButton.set("tooltip", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.SubmitButton.tooltip"));

        if (this.isSubmitting) {
            $submitButton.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.submitButton.submitting"]);
        }
        else {
            $submitButton.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.submitButton.neutral"]);
        }
        $submitButton.addRemoveClass("loading", this.isSubmitting);
    },

    /**
     * @method
     * @private
     */
    absoluteShowingChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.absoluteShowing
                && !this.app.$.continueSignUpPopup.get("showing")
                && !this.app.$.privacyService.get("cmpUiShown")
            ) {
                this.$.isAdultLabel.focus();
            }
        };
    }),

    /**
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    onActivate: function(sender, event) {
        var $isAdultRadio = this.$.isAdultRadio,
            $isKidRadio   = this.$.isKidRadio,
            $isAdultIcon  = this.$.isAdultIcon,
            $isKidIcon    = this.$.isKidIcon;

        // Adult active
        if ($isAdultRadio.get("active")) {
            $isAdultIcon.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.isAdultIcon.checked"]);

            if (event.originator === $isAdultRadio) {
                $isKidRadio.set("active", false);
            }
        }
        else {
            $isAdultIcon.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.isAdultIcon.unchecked"]);
        }

        // Kid active
        if ($isKidRadio.get("active")) {
            $isKidIcon.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.isKidIcon.checked"]);

            if (event.originator === $isKidRadio) {
                $isAdultRadio.set("active", false);
            }
        }
        else {
            $isKidIcon.set("icon", icons["app.ProfilePage.ChangeIsAdultForm.isKidIcon.unchecked"]);
        }


    },

    // Submit form
    // --------------------------------
    // The methods below are used to handle form submission.
    // --------------------------------

    /**
     * Should prevent blurring the password input.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    onPasswordVisibilityDown: function(sender, event) {
        event.preventDefault();
    },

    /**
     * Toggles the visibility of the password.
     *
     * @private
     */
    onPasswordVisibilityTap: function() {
        this.set("passwordVisible", !this.get("passwordVisible"));
    },

    /**
     * Validate the form and submit a request for a new password as needed.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @private
     */
    submit: function(sender, event) {
        var formNode    = this.hasNode(),
            autofocusNode,
            authService = this.app.$.authService,
            isAdultValue,
            passwordValue;

        // Don't send, we'll go through the Authentication service for that.
        event.preventDefault();

        // Nothing to do right now.
        if (!formNode || this.isSubmitting) {
            return;
        }

        // If form isn't valid, focus first field with error and leave it at
        // that.
        if (!this.validateForm()
            && !this.app.$.continueSignUpPopup.get("showing")
            && !this.app.$.privacyService.get("cmpUiShown")
        ) {
            autofocusNode = formNode.querySelector(".invalid");
            autofocusNode && autofocusNode.focus();

            return;
        }

        // Get form values
        if (this.$.isAdultRadio.get("active")) {
            isAdultValue = true;
        }
        else if (this.$.isKidRadio.get("active")) {
            isAdultValue = false;
        }
        else {
            isAdultValue = null;
        }
        passwordValue = this.$.passwordInput.get("value");
        passwordValue = passwordValue.length ? passwordValue : "";

        // Submit form
        this.set("isSubmitting", true);
        authService
            .changeProfile({is_adult: isAdultValue}, passwordValue)
            .then(this.bindSafely(function(response) {
                switch (response.status) {
                    case "ok":
                        this.onSuccess();
                        break;
                    case "error":
                    default:
                        this.onFail(response.type || "unknown_error");
                        break;
                }
                this.set("isSubmitting", false);
            }))
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                this.onFail(error.message || "unknown_error");
                this.set("isSubmitting", false);
            }));
    },

    /**
     * Validate form field on blur.
     *
     * @protected
     */
    onFormControlBlur: function() {
        // If we validate when someone is clicking the close button, the form
        // might show an error message before the pointer goes back up. This
        // could cause the popup to resize and get taller, moving the close
        // button out from underneath the pointer. This will then prevent the
        // intended click. The easiest way to prevent this from happening is
        // just to not validate the form when someone is clicking the close
        // button.
        if (!this.get("isCloseButtonDown")) {
            this.validateForm();
        }
    },

    /**
     * Focus the tapped form control.
     *
     * @param  {enyo.Control}  sender  The control that just got tapped.
     * @protected
     */
    onFormControlTap: function(sender) {
        sender.focus();
    },

    /**
     * Validate the entire form.
     *
     * @returns  {boolean}  Whether the form is valid.
     * @protected
     */
    validateForm: function() {
        var controlNames = ["isAdultRadio", "isKidRadio", "passwordInput"],
            isValid      = true;

        controlNames.forEach(this.bindSafely(function(name) {
            var control = this.$[name];

            if (!control || !this.validateField(control)) {
                isValid = false;
            }
        }));

        return isValid;
    },

    /**
     * Validates the field, returns whether it is valid.
     *
     * @param  {enyo.Control}  control  The form control
     * @return {boolean}       `true` if valid, `false` otherwise
     */
    validateField: function(control) {
        var node = control.hasNode();

        // Field is valid
        if (node && (
            node.disabled
            || node.type === "submit"
            || node.validity.valid)) {
            control.removeClass("invalid");

            return true;
        }

        // Field is invalid
        else {
            control.addClass("invalid");

            return false;
        }
    },

    /**
     * @private
     */
    onSuccess: function() {
        // Hide form error alert
        this.$.formErrorAlert.hide();

        // Success!
        this.emit("success");

        // Close this form
        this.close();
    },

    /**
     * @param  {string}  error  The error
     * @private
     */
    onFail: function(error) {
        var $formErrorAlert = this.$.formErrorAlert,
            i18nService     = this.app.$.i18nService;

        switch (error) {
            case "invalid_is_adult":
                $formErrorAlert.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.invalidIsAdult"));
                $formErrorAlert.show();
                break;
            case "invalid_password":
                $formErrorAlert.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.invalidPassword"));
                $formErrorAlert.show();
                break;
            case "password_required":
                $formErrorAlert.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.passwordRequired"));
                $formErrorAlert.show();
                break;
            case "no_session":
                this.emit("login_required");
                $formErrorAlert.hide();
                this.close();

                return;
            case "server_error":
            default:
                $formErrorAlert.set("content", i18nService.getString("app.ProfilePage.ChangeIsAdultForm.serverError"));
                $formErrorAlert.show();
                break;
        }
    },

    /**
     * Reset form.
     *
     * @private
     */
    resetForm: function() {
        this.$.passwordInput.set("value", "");
    },

    /**
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            // Needed to hide the scrim and loading graphic again.
            if (this.isSubmitting) {
                this.set("isSubmitting", false);
            }
            sup.apply(this, arguments);
        };
    })

});
